var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "announcement-list pb-4 mb-6",
      attrs: { "data-testid": "announcement-list" },
    },
    [
      _c(
        "div",
        { staticClass: "announcement-list-header" },
        [
          _c("v-icon", { staticClass: "mr-2" }, [_vm._v("campaign")]),
          _vm._v(" "),
          _c("span", { staticClass: "font-weight-bold" }, [
            _vm._v(_vm._s(_vm.$t("title"))),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "announcement-list-items pl-5 pt-2" },
        _vm._l(_vm.announcements, function (item) {
          return _c(
            "div",
            {
              key: item.url,
              staticClass: "announcement-list-item",
              attrs: { "data-testid": "announcement-item" },
            },
            [
              _c("span", { staticClass: "pr-2" }, [_vm._v("・")]),
              _vm._v(" "),
              item.url
                ? _c(
                    "a",
                    {
                      attrs: {
                        href: item.url,
                        target: "_blank",
                        rel: "noopener noreferrer",
                      },
                    },
                    [_vm._v("\n        " + _vm._s(item.title) + "\n      ")]
                  )
                : _c("span", [_vm._v(_vm._s(item.title))]),
              _vm._v(" "),
              _vm.isNew(item.date)
                ? _c(
                    "span",
                    {
                      staticClass: "announcement-list-item-new ml-2",
                      attrs: { "data-testid": "new-badge" },
                    },
                    [_vm._v("NEW")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "announcement-list-item-date ml-2",
                  attrs: { "data-testid": "announcement-date" },
                },
                [_vm._v(_vm._s(_vm.formatDate(item.date)))]
              ),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }